// Records a query-param change in the URL for UI that has already updated itself (an open
// sidebar, a selected tab panel).
//
// The write goes through Turbo's own history so Turbo stays the owner of the entry. Writing
// `history.replaceState({}, ...)` instead strips the `turbo` state Turbo put there: the entry is
// then one Turbo will not restore, so a later back/forward onto it moves the address bar while
// the previous page stays on screen. It also leaves Turbo's idea of the current location stale,
// which mis-keys the snapshot it caches. See docs/turbo_2.0.23_update.md.

export const updateUrlParams = (params, usePushState = false) => {
  const url = new URL(window.location.href)

  Object.entries(params).forEach(([key, value]) => {
    if (value === null || value === undefined) {
      url.searchParams.delete(key)
    } else {
      url.searchParams.set(key, value)
    }
  })

  const newUrl = url.toString()
  const turboHistory = window.Turbo?.session?.history

  if (turboHistory) {
    turboHistory[usePushState ? 'push' : 'replace'](url)
  } else {
    // Turbo is not running on this page (e.g. the Active Admin pack): plain history is equivalent.
    window.history[usePushState ? 'pushState' : 'replaceState'](window.history.state, '', newUrl)
  }

  return newUrl
}
